import React, { useEffect, useState } from "react";
import { FiShield } from "react-icons/fi";
import { usePmsTheme } from "../Components/PmsThemeContext";
import { getDemoCopy } from "./demoI18n";
import { loadDemoSnapshot, peekDemoSnapshot } from "./demoSnapshot";
import "./DemoModeBanner.css";

export default function DemoModeBanner() {
  const { languageId } = usePmsTheme();
  const copy = getDemoCopy(languageId);
  const [snapshot, setSnapshot] = useState(peekDemoSnapshot);
  useEffect(() => {
    let active = true;
    loadDemoSnapshot().then((value) => { if (active) setSnapshot(value); }).catch(() => {});
    return () => { active = false; };
  }, []);
  const snapshotDate = snapshot?.reference_date
    ? new Date(`${snapshot.reference_date}T12:00:00`).toLocaleDateString(languageId)
    : "";

  return (
    <aside className="demoModeBanner" aria-label={copy.bannerAria}>
      <div className="demoModeBanner__status">
        <FiShield size={15} aria-hidden="true" />
        <strong>{copy.interactive}</strong>
        <span>Hotel Travesía</span>
        <span className="demoModeBanner__readOnly">{copy.readOnly}</span>
        {snapshotDate && <span>{copy.snapshotDate} {snapshotDate}</span>}
      </div>
    </aside>
  );
}
